import { Updater, VisibilityState } from '@tanstack/react-table';
import { useEffect, useState } from 'react';
import { StorageKeyMap, StorageUtilities } from '@dealstack/frontend/shared/helper/storageUtils.ts';

export const useTableColPreferences = (params: {
	storageKey: keyof StorageKeyMap;
	defaultColumnVisibility: VisibilityState;
}): TableColPreferences => {
	const { storageKey, defaultColumnVisibility } = params;
	const [columnVisibility, setColumnVisibility] = useState(defaultColumnVisibility);

	useEffect(() => {
		const savedColumnVisibility = StorageUtilities.getItem<VisibilityState>(storageKey);

		if (savedColumnVisibility) {
			// Merge defaults with saved — new default-hidden columns stay hidden
			// unless the user previously toggled them explicitly
			setColumnVisibility({ ...defaultColumnVisibility, ...savedColumnVisibility });
		}
	}, []);

	const handleColumnVisibilityChange = (newColumnVisibility: Updater<VisibilityState>) => {
		const visibilityState =
			typeof newColumnVisibility === 'function'
				? newColumnVisibility(columnVisibility)
				: newColumnVisibility;

		StorageUtilities.setItem(storageKey, visibilityState);
		setColumnVisibility(visibilityState);
	};

	return {
		columnVisibility,
		handleColumnVisibilityChange,
	};
};

interface TableColPreferences {
	columnVisibility: VisibilityState;
	handleColumnVisibilityChange: (newColumnVisibility: Updater<VisibilityState>) => void;
}
